import React, {useEffect} from 'react';
import { useLocation, useParams} from "react-router-dom";
import SessionHelper from '../../../session/SessionHelper';
import api from '../../../_utility/AxiosConfig';
import { useUser } from '../../../_context/UserContext';

function SocialLoginCallback(){
    const { setAuthUserId, setAuthUser } = useUser();
    const location = useLocation();
    const params = useParams();

    useEffect(() => {
        const handleAuthCallback = async () => {
          try {
            const res = await api.post('/api/auth/' + params.provider + '/callback' + location.search);
            if(res.data.user)
            {
                SessionHelper.SetAuthSession(res.data.user);
                setAuthUser(res.data.user);
                setAuthUserId(res.data.user.user_id);
                // Send a message to the main window with user data if this open inside popup
                window.opener.postMessage({ type: 'USER_LOGGED_IN', user: res.data.user }, '*');
            }
            window.close();
          } catch (error) {
            // console.error('Error during callback:', error);
            window.close();
          }
        };
    
        handleAuthCallback();
      }, [params.provider, location.search]);

    return (
        <>
            <section className="faq-area padding-top-100px padding-bottom-60px">
                <div className="container">
                    <div className="row padding-top-60px">
                        <div className="col-sm-6 offset-sm-3 contact-form-action">
                            <div className="form-box">
                                <div className="form-content text-center mb-5 mt-5">
                                    <i className="las la-spin la-spinner la-3x text-info"></i>
                                    <p className="text-info font-weight-bold font-size-20 mt-3">Please wait while we are processing your request..</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default SocialLoginCallback;
